function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import 'prop-types';
import 'react';
import { jsx } from '@emotion/core';
import { ButtonToolbar, ButtonGroup, Button, Icon } from '@appfolio/react-gears';
import { observer } from 'mobx-react';
import _css from '@emotion/css';

var ContextMenu = function ContextMenu(_ref) {
  var pageStore = _ref.pageStore;
  if (!pageStore.contextMenu) return null;

  var handleCopy = function handleCopy() {
    var selectedFields = pageStore.pdfStore.selectedFields;
    pageStore.pdfStore.setCopiedFields(_toConsumableArray(selectedFields));
    pageStore.pdfStore.setContextMenu();
  };

  var handleDelete = function handleDelete() {
    var _pageStore$pdfStore$s;

    (_pageStore$pdfStore$s = pageStore.pdfStore.selectedFields) === null || _pageStore$pdfStore$s === void 0 ? void 0 : _pageStore$pdfStore$s.forEach(function (field) {
      pageStore.deleteField(field);
    });
    pageStore.pdfStore.setContextMenu();
    pageStore.pdfStore.setSelectedFields();
    pageStore.pdfStore.setLastFieldClicked();
  };

  var menuWidth = 85;
  var xPosition = pageStore.contextMenu.position.x;

  if (pageStore.unScale(xPosition + menuWidth) > pageStore.width) {
    xPosition -= menuWidth;
  }

  var menuHeight = 61;
  var yPosition = pageStore.contextMenu.position.y;

  if (pageStore.unScale(yPosition + menuHeight) > pageStore.height) {
    yPosition -= menuHeight;
  }

  return jsx(ButtonToolbar, {
    className: "m-0",
    css: /*#__PURE__*/_css({
      position: 'absolute',
      width: menuWidth,
      height: menuHeight,
      left: "".concat(xPosition, "px"),
      top: "".concat(yPosition, "px")
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  }, jsx(ButtonGroup, {
    vertical: true
  }, jsx(Button, {
    onClick: handleCopy
  }, jsx(Icon, {
    name: "clone",
    className: "me-2"
  }), "Copy"), jsx(Button, {
    onClick: handleDelete
  }, jsx(Icon, {
    name: "times",
    className: "me-2"
  }), "Delete")));
};

ContextMenu.displayName = "ContextMenu";
var ContextMenu$1 = observer(ContextMenu);
export default ContextMenu$1;